import {Nullable} from '../../../types/utils'
import {ProductModel} from '../../../store/ProductStore'
import {useCustomerStore} from '../../../store/hooks/useStore'

type CalculateItemPriceProps = {
  hit: Nullable<ProductModel>
  selectedPriceDayOffset: number | undefined
  selectedRegion: number
  getApplicablePromotions: ReturnType<typeof useCustomerStore>['getApplicablePromotions']
}

export const calculateItemPrice = ({
  hit,
  selectedPriceDayOffset,
  selectedRegion,
  getApplicablePromotions
}: CalculateItemPriceProps) => {
  const {onlineExclusivePromo} = getApplicablePromotions(hit?.productPromotions)
  let displayPrice: Nullable<number> = null
  let promotionPrice: Nullable<number> = null
  let wasPrice: Nullable<number> = null
  let lowestPrice: Nullable<number> = null
  let lowestWasPrice: Nullable<number> = null

  if (hit) {
    // Gets an array of prices for that day indexed by region, take day one if no selectedPriceDay
    displayPrice =
      selectedPriceDayOffset != null
        ? hit.matrixPrices?.[selectedPriceDayOffset]?.[selectedRegion]
        : null

    if (displayPrice === null) {
      displayPrice = hit.matrixPrices?.[0]?.[0]
    }

    if (onlineExclusivePromo?.promotionPrice !== undefined) {
      promotionPrice = onlineExclusivePromo.promotionPrice
    }

    if (hit.priceInfo?.wasPrice) {
      wasPrice = Number(hit.priceInfo.wasPrice)
    }

    // Work out the lowest price and was price (if applicable) to decide which values to set
    if (displayPrice) {
      lowestPrice = promotionPrice ? Math.min(displayPrice, promotionPrice) : displayPrice
      lowestWasPrice =
        wasPrice && promotionPrice && promotionPrice < displayPrice
          ? displayPrice
          : wasPrice ?? null
    }
  }

  return {
    displayPrice,
    promotionPrice,
    lowestPrice,
    lowestWasPrice
  }
}